/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated.index"
import { Route as InviteTokenRouteImport } from "./routes/invite.$token"
import { Route as AuthenticatedOrgSlugRouteImport } from "./routes/_authenticated/$orgSlug"
import { Route as AuthenticatedOrgSlugIndexRouteImport } from "./routes/_authenticated/$orgSlug.index"
import { Route as AuthenticatedOrgSlugNewProjectRouteImport } from "./routes/_authenticated/$orgSlug.new-project"
import { Route as AuthenticatedOrgSlugIdRouteImport } from "./routes/_authenticated/$orgSlug.$id"
import { Route as AuthenticatedOrgSlugIdIndexRouteImport } from "./routes/_authenticated/$orgSlug.$id.index"
import { Route as AuthenticatedOrgSlugIdSelectRouteImport } from "./routes/_authenticated/$orgSlug.$id.select"
import { Route as AuthenticatedOrgSlugIdSplatRouteImport } from "./routes/_authenticated/$orgSlug.$id.$"

const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOrgSlugRoute = AuthenticatedOrgSlugRouteImport.update({
  id: "/$orgSlug",
  path: "/$orgSlug",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrgSlugIndexRoute =
  AuthenticatedOrgSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugNewProjectRoute =
  AuthenticatedOrgSlugNewProjectRouteImport.update({
    id: "/new-project",
    path: "/new-project",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugIdRoute = AuthenticatedOrgSlugIdRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => AuthenticatedOrgSlugRoute,
} as any)
const AuthenticatedOrgSlugIdIndexRoute =
  AuthenticatedOrgSlugIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedOrgSlugIdRoute,
  } as any)
const AuthenticatedOrgSlugIdSelectRoute =
  AuthenticatedOrgSlugIdSelectRouteImport.update({
    id: "/select",
    path: "/select",
    getParentRoute: () => AuthenticatedOrgSlugIdRoute,
  } as any)
const AuthenticatedOrgSlugIdSplatRoute =
  AuthenticatedOrgSlugIdSplatRouteImport.update({
    id: "/$",
    path: "/$",
    getParentRoute: () => AuthenticatedOrgSlugIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute
  "/login": typeof LoginRoute
  "/$orgSlug": typeof AuthenticatedOrgSlugRouteWithChildren
  "/invite/$token": typeof InviteTokenRoute
  "/$orgSlug/$id": typeof AuthenticatedOrgSlugIdRouteWithChildren
  "/$orgSlug/new-project": typeof AuthenticatedOrgSlugNewProjectRoute
  "/$orgSlug/": typeof AuthenticatedOrgSlugIndexRoute
  "/$orgSlug/$id/$": typeof AuthenticatedOrgSlugIdSplatRoute
  "/$orgSlug/$id/select": typeof AuthenticatedOrgSlugIdSelectRoute
  "/$orgSlug/$id/": typeof AuthenticatedOrgSlugIdIndexRoute
}
export interface FileRoutesByTo {
  "/login": typeof LoginRoute
  "/invite/$token": typeof InviteTokenRoute
  "/": typeof AuthenticatedIndexRoute
  "/$orgSlug/new-project": typeof AuthenticatedOrgSlugNewProjectRoute
  "/$orgSlug": typeof AuthenticatedOrgSlugIndexRoute
  "/$orgSlug/$id/$": typeof AuthenticatedOrgSlugIdSplatRoute
  "/$orgSlug/$id/select": typeof AuthenticatedOrgSlugIdSelectRoute
  "/$orgSlug/$id": typeof AuthenticatedOrgSlugIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/login": typeof LoginRoute
  "/_authenticated/$orgSlug": typeof AuthenticatedOrgSlugRouteWithChildren
  "/invite/$token": typeof InviteTokenRoute
  "/_authenticated/": typeof AuthenticatedIndexRoute
  "/_authenticated/$orgSlug/$id": typeof AuthenticatedOrgSlugIdRouteWithChildren
  "/_authenticated/$orgSlug/new-project": typeof AuthenticatedOrgSlugNewProjectRoute
  "/_authenticated/$orgSlug/": typeof AuthenticatedOrgSlugIndexRoute
  "/_authenticated/$orgSlug/$id/$": typeof AuthenticatedOrgSlugIdSplatRoute
  "/_authenticated/$orgSlug/$id/select": typeof AuthenticatedOrgSlugIdSelectRoute
  "/_authenticated/$orgSlug/$id/": typeof AuthenticatedOrgSlugIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/$orgSlug"
    | "/invite/$token"
    | "/$orgSlug/$id"
    | "/$orgSlug/new-project"
    | "/$orgSlug/"
    | "/$orgSlug/$id/$"
    | "/$orgSlug/$id/select"
    | "/$orgSlug/$id/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/login"
    | "/invite/$token"
    | "/"
    | "/$orgSlug/new-project"
    | "/$orgSlug"
    | "/$orgSlug/$id/$"
    | "/$orgSlug/$id/select"
    | "/$orgSlug/$id"
  id:
    | "__root__"
    | "/_authenticated"
    | "/login"
    | "/_authenticated/$orgSlug"
    | "/invite/$token"
    | "/_authenticated/"
    | "/_authenticated/$orgSlug/$id"
    | "/_authenticated/$orgSlug/new-project"
    | "/_authenticated/$orgSlug/"
    | "/_authenticated/$orgSlug/$id/$"
    | "/_authenticated/$orgSlug/$id/select"
    | "/_authenticated/$orgSlug/$id/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/": {
      id: "/_authenticated/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/invite/$token": {
      id: "/invite/$token"
      path: "/invite/$token"
      fullPath: "/invite/$token"
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/$orgSlug": {
      id: "/_authenticated/$orgSlug"
      path: "/$orgSlug"
      fullPath: "/$orgSlug"
      preLoaderRoute: typeof AuthenticatedOrgSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/$orgSlug/": {
      id: "/_authenticated/$orgSlug/"
      path: "/"
      fullPath: "/$orgSlug/"
      preLoaderRoute: typeof AuthenticatedOrgSlugIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/new-project": {
      id: "/_authenticated/$orgSlug/new-project"
      path: "/new-project"
      fullPath: "/$orgSlug/new-project"
      preLoaderRoute: typeof AuthenticatedOrgSlugNewProjectRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/$id": {
      id: "/_authenticated/$orgSlug/$id"
      path: "/$id"
      fullPath: "/$orgSlug/$id"
      preLoaderRoute: typeof AuthenticatedOrgSlugIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/$id/": {
      id: "/_authenticated/$orgSlug/$id/"
      path: "/"
      fullPath: "/$orgSlug/$id/"
      preLoaderRoute: typeof AuthenticatedOrgSlugIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugIdRoute
    }
    "/_authenticated/$orgSlug/$id/select": {
      id: "/_authenticated/$orgSlug/$id/select"
      path: "/select"
      fullPath: "/$orgSlug/$id/select"
      preLoaderRoute: typeof AuthenticatedOrgSlugIdSelectRouteImport
      parentRoute: typeof AuthenticatedOrgSlugIdRoute
    }
    "/_authenticated/$orgSlug/$id/$": {
      id: "/_authenticated/$orgSlug/$id/$"
      path: "/$"
      fullPath: "/$orgSlug/$id/$"
      preLoaderRoute: typeof AuthenticatedOrgSlugIdSplatRouteImport
      parentRoute: typeof AuthenticatedOrgSlugIdRoute
    }
  }
}

interface AuthenticatedOrgSlugIdRouteChildren {
  AuthenticatedOrgSlugIdSplatRoute: typeof AuthenticatedOrgSlugIdSplatRoute
  AuthenticatedOrgSlugIdSelectRoute: typeof AuthenticatedOrgSlugIdSelectRoute
  AuthenticatedOrgSlugIdIndexRoute: typeof AuthenticatedOrgSlugIdIndexRoute
}

const AuthenticatedOrgSlugIdRouteChildren: AuthenticatedOrgSlugIdRouteChildren =
  {
    AuthenticatedOrgSlugIdSplatRoute: AuthenticatedOrgSlugIdSplatRoute,
    AuthenticatedOrgSlugIdSelectRoute: AuthenticatedOrgSlugIdSelectRoute,
    AuthenticatedOrgSlugIdIndexRoute: AuthenticatedOrgSlugIdIndexRoute,
  }

const AuthenticatedOrgSlugIdRouteWithChildren =
  AuthenticatedOrgSlugIdRoute._addFileChildren(
    AuthenticatedOrgSlugIdRouteChildren,
  )

interface AuthenticatedOrgSlugRouteChildren {
  AuthenticatedOrgSlugIdRoute: typeof AuthenticatedOrgSlugIdRouteWithChildren
  AuthenticatedOrgSlugNewProjectRoute: typeof AuthenticatedOrgSlugNewProjectRoute
  AuthenticatedOrgSlugIndexRoute: typeof AuthenticatedOrgSlugIndexRoute
}

const AuthenticatedOrgSlugRouteChildren: AuthenticatedOrgSlugRouteChildren = {
  AuthenticatedOrgSlugIdRoute: AuthenticatedOrgSlugIdRouteWithChildren,
  AuthenticatedOrgSlugNewProjectRoute: AuthenticatedOrgSlugNewProjectRoute,
  AuthenticatedOrgSlugIndexRoute: AuthenticatedOrgSlugIndexRoute,
}

const AuthenticatedOrgSlugRouteWithChildren =
  AuthenticatedOrgSlugRoute._addFileChildren(AuthenticatedOrgSlugRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedOrgSlugRoute: typeof AuthenticatedOrgSlugRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOrgSlugRoute: AuthenticatedOrgSlugRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
